export enum ECargoTransporterRouteRateEditingEntity{
    None,
    Rate,
    VehicleCount
}